export default [
  'zh-TW',
  'en'
]
